<template>
  <div class="ph-wrap">
    <div class="ph-left">
      <span class="ph-bar"></span>
      <span class="ph-title" :class="{ 'ph-title--lg': large }">{{ title }}</span>
      <span v-if="subtitle" class="ph-sub">{{ subtitle }}</span>
    </div>
    <div v-if="$slots.default" class="ph-right">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title:    { type: String, required: true },
    subtitle: { type: String, default: '' },
    large:    { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.ph-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  margin-bottom: 20px;
}

.ph-left {
  display: flex;
  align-items: center;
}

.ph-bar {
  width: 4px;
  height: 20px;
  background: #1769E8;
  border-radius: 2px;
  flex-shrink: 0;
}

.ph-title {
  font-size: $font-xl;
  font-weight: $fw-heavy;
  color: $text-primary;
  margin-left: 10px;

  &--lg {
    font-size: $font-3xl;
    margin-left: 14px;
  }
}

.ph-sub {
  font-size: $font-sm;
  color: $text-muted;
  margin-left: 12px;
}

.ph-right {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
